import { Radio } from "antd";
import React, { useMemo } from 'react';
import { IPropsElement } from "../../../pages/ChecklistPage/PopupEdit/constants";
import { callEventChecklist, getChecklist, useChecklist } from "../ChecklistContext";

const RadioElement: React.FC<IPropsElement> = (props) => {
    const { options = '', numberOfColumns = 1, optionDefault } = props.properties;
    const { index } = props;
    const [value = optionDefault] = useChecklist(state => state.result[index]);
    const { onResultChange } = callEventChecklist();
    const { disabled } = getChecklist()();

    const opts = useMemo(() => options.length > 0 ? options.split('\n').reduce((list: any[], item, index) => {
        if (item.trim().length > 0)
            list = [...list, { label: item, value: `${index}` }]
        return list;
    }, []) : [], [options]);

    const style: any = {
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`
    };

    return <Radio.Group
        disabled={disabled}
        style={style}
        options={opts}
        value={value}
        onChange={({ target }) => onResultChange({ [index]: target.value })}
    />

};

export default RadioElement;
